export default __webpack_public_path__ + "static/media/mustard-yellow-3-designify.61431887.png";